import {Dispatch} from 'react'
import {SUJETO_EXCLUIDO_TYPES} from '../../constants/sujetoExcluido.types'
import {State} from '../../reducers'
import {validacionEsRequerido} from '../../utils/validaciones'
import {sujetoExcluidoSetCatalogoSerie} from './sujetoExcluidoEmision.actions'
import { SujetoExcluidoAction } from '../../interfaces/sujeto-excluido.interface'

// ******************************************************************************************
export const sujetoExcluidoFormSucursalHandleChange = (formSucursal: any) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_FORMSUCURSAL_HANDLE_CHANGE,
  payload: formSucursal,
})

export const sujetoExcluidoFormSucursalAddError = (error: any) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_FORMSUCURSAL_SET_ERRORS,
  payload: error,
})

// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************
export const sujetoExcluidoFormSucursalHandleChangeInput =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) =>
  async (dispatch: Dispatch<SujetoExcluidoAction>) => {
    let {name, value} = e.target
    switch (name) {
      case 'sucursal':
        dispatch(sujetoExcluidoFormSucursalHandleChange({serie: ''}))
        break
      case 'serie':
        break
      default:
        break
    }
    dispatch(sujetoExcluidoFormSucursalHandleChange({[name]: value}))
  }

// ******************************************************************************************
// ? VALIDACIONES
// ******************************************************************************************
export const sujetoExcluidoFormSucursalOnBlur =
  (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) =>
  async (dispatch: Dispatch<SujetoExcluidoAction>, getState: () => State) => {
    let {name, value} = e.target
    let message = ''
    switch (name) {
      case 'sucursal':
        message = validacionEsRequerido(value, message, 'Sucursal', 'requerida')

        let sucursal = getState().sujetoExcluido.catalogoSucursal.find(
          (suc) => suc?.idsucursal === value
        )
        dispatch(
          sujetoExcluidoFormSucursalHandleChange({
            datosSucursal: sucursal || null,
            serie: '',
            datosSerie: null,
          })
        )
        dispatch(sujetoExcluidoSetCatalogoSerie(sucursal ? sucursal?.Documento : []))
        break
      case 'serie':
        message = validacionEsRequerido(value, message, 'Serie', 'requerida')
        let serie = getState().sujetoExcluido.catalogoSerie.find(
          (ser) => ser?.idsucursaldocumento === value
        )
        dispatch(sujetoExcluidoFormSucursalHandleChange({datosSerie: serie || null}))
        break
      default:
        break
    }
    dispatch(sujetoExcluidoFormSucursalAddError({[name]: message}))
  }

export const sujetoExcluidoFormSucursalValidacion = (
  dispatch: Dispatch<SujetoExcluidoAction>,
  getState: () => State
) => {
  const {formSucursal, errorsFormSucursal} = getState().sujetoExcluido
  // Validaciones
  errorsFormSucursal.sucursal = validacionEsRequerido(
    formSucursal.sucursal,
    errorsFormSucursal.sucursal,
    'Sucursal',
    'requerida'
  )
  errorsFormSucursal.serie = validacionEsRequerido(
    formSucursal.serie,
    errorsFormSucursal.serie,
    'Serie',
    'requerida'
  )
  dispatch(sujetoExcluidoFormSucursalAddError(errorsFormSucursal))
  if (errorsFormSucursal.sucursal || errorsFormSucursal.serie) return true
  return false
}
